import { render, staticRenderFns } from "./IndividualSLP.vue?vue&type=template&id=cfbf22ae&scoped=true&"
import script from "./IndividualSLP.vue?vue&type=script&lang=ts&"
export * from "./IndividualSLP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbf22ae",
  null
  
)

export default component.exports